import React, { useContext, useState, useEffect } from "react";
import Section from "../../../UIcomponent/Section";
import Col from "../../../UIcomponent/Column";
import { Title } from "../../../UIcomponent/Title";
import "./Introduction.scss";
import LocalContext from "../../../Context/LocalContetxt";
import { ThemeContext } from "styled-components";
import IntroductionDic from "./IntroductionDic";
import Text from "../../../UIcomponent/Text";
import { Rate } from "../../../UIcomponent/Rate";
// import AvatarDefault from '../../../Assets/images/AvatarDefault.jpg'
import ReactPlayer from "react-player";
import Urls from "../../../Utility/Urls";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import AppConfig from "../../../Utility/Method/AppConfig";
import StyledAvatar from "../../../UIcomponent/StyledAvatar";
import AparatPlayer from "../../../Component/AparatPlayer";
const Introduction = (props) => {
  const theme = useContext(ThemeContext);
  const lang = useContext(LocalContext).lang;
  const { intro } = props;
  const [needToggle, setNeedToggle] = useState(false);
  const [toggled, setToggled] = useState(false);
  let width = window.innerWidth;
  const MaxCharAboutMe =
    width > 1280 ? 220 : 768 < width && width < 1280 ? 180 : 90;
  let loading = !intro ? true : false;
  const CategoryStr = (arr) => {
    let str = "";
    let CategoryList = [];
    arr.forEach((each, index) => {
      CategoryList.push(each);
    });
    str = `${CategoryList.join(" - ")}`;
    return (
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        className="o__Base__More__Content__Desc"
      >
        {str}
      </Col>
    );
  };
  const ToggleController = () => {
    setToggled(!toggled);
  };
  useEffect(() => {
    if (intro && intro.AboutMe) {
      setNeedToggle(intro.AboutMe.length > MaxCharAboutMe ? true : false);
    }
  }, [intro, MaxCharAboutMe]);
  return (
    <Section
      flexDir="column"
      className="l__Intro"
      style={{
        // justifyContent: 'flex-start',
        width: "100%",
        height: "auto",
      }}
    >
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        className="c__Video"
        // height={!loading ? 'auto' : '450px'}
        loading={loading}
      >
        {
          !loading && (
            <AparatPlayer
              baseUrl={`${Urls.baseUrl()}`}
              video={intro ? intro.IntroAparat : ""}
              primary={theme.primary}
              borderRadius="7px 7px 0px 0px"
              // height="auto"
              // width="100%"
              secondary={"white"}
              overlay={theme.lightGlass}
            />
          )
          // }
          // <ReactPlayer
          //     style={{
          //         outLine: 'none'
          //     }}
          //     playing={false}
          //     controls={true}
          //     autoPlay={false}
          //     height={!loading ? 'auto' : '450px'}
          //     // height='auto'
          //     width='100%'
          //     volume={0.5}
          //     url={intro && Urls.video() + intro.IntroductionVideo} />
        }
      </Col>
      <Col xl={24} lg={24} md={24} sm={22} xs={22} className="c__Info">
        <Col xl={4} lg={4} md={4} sm={6} xs={6} className="o__Info__Avatar">
          <StyledAvatar
            loading={loading}
            size={90}
            alt={intro && `${intro.FirstName} ${intro.LastName}`}
            source={
              intro &&
              intro.UserAvatar &&
              intro.UserAvatar !== "" &&
              Urls.avatar() +
                (intro.UserAvatar.includes(".jpg")
                  ? intro.UserAvatar.split(".jpg").join("_thumb.jpg")
                  : intro.UserAvatar.includes(".png")
                  ? intro.UserAvatar.split(".png").join("_thumb.png")
                  : intro.UserAvatar)
            }
          />
        </Col>
        <Col xl={12} lg={13} md={13} sm={24} xs={24} className="o__Info__Base">
          <Col
            className="o__Info__Base__Name"
            // xl={24} lg={24} md={24} sm={24} xs={24}
            skeletonType="line"
            loading={loading}
          >
            <h1 style={{ all: "unset" }}>
              {intro ? intro.FirstName + " " + intro.LastName : ""}
            </h1>
          </Col>
          {/* <Col
                        xl={24} lg={24} md={24} sm={24} xs={24}
                        className='o__Info__Base__Locaton'
                    >
                        <Text>
                            {intro.City + '/' + intro.Country}

                        </Text>

                    </Col> */}
          <Col
            className="o__Info__Base__Skills"
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            skeletonType="line"
            loading={loading}
          >
            {intro && (
              <>
                <Title className="o__Info__Base__Skills__Title">
                  {IntroductionDic.teacher[`${lang}`]}
                </Title>
                <Col className="o__Info__Base__Skills__Value">
                  {AppConfig.Language(intro.TeachingLanguages)[`${lang}`]}
                </Col>
              </>
            )}
          </Col>
          <Col
            className="o__Info__Base__Category"
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            skeletonType="line"
            loading={loading}
          >
            {intro && (
              <>
                <Title className="o__Info__Base__Category__Title">
                  مهارت ها
                </Title>
                <Col className="o__Info__Base__Category__Value">
                  {CategoryStr(
                    Object.keys(intro.AllowedCategories)
                      .filter((key, index) => {
                        return intro.AllowedCategories[key] === true;
                      })
                      .map((each) => AppConfig.Category(each)[`${lang}`])
                  )}
                </Col>
              </>
            )}
          </Col>
        </Col>
        <Col xl={6} lg={5} md={5} sm={18} xs={18} className="o__Info__More">
          {intro && intro.Rate === 0 && (
            <Col className="o__Info__More__Lable">جدید</Col>
          )}
          {intro && intro.Rate > 0 && (
            <Col className="o__Info__More__Rate">
              {intro && (
                <Text>
                  {intro.Rate.toString().length > 3
                    ? intro.Rate.toFixed(1)
                    : intro.Rate}
                </Text>
              )}
              <Rate
                value={intro.Rate}
                allowHalf={true}
                allowClear={false}
                disabled={true}
                icon={<StarRoundedIcon fontSize="inherit" />}
                style={{
                  direction: lang === "fa" || lang === "ar" ? "ltr" : "rtl",
                  color: theme.warning,
                  opacity: 1,
                }}
                size="larg"
              />
            </Col>
          )}
          {intro && intro.SessionCount > 0 && (
            <Col className="o__Info__More__Session">
              {intro && <Text>{intro.SessionCount}</Text>}

              <Text>{IntroductionDic.class[`${lang}`]}</Text>
            </Col>
          )}
          {intro && intro.StudentCount > 0 && (
            <Col className="o__Info__More__Student">
              {intro && <Text>{intro.StudentCount}</Text>}
              <Text>{IntroductionDic.student[`${lang}`]}</Text>
            </Col>
          )}
        </Col>
      </Col>
      {intro && (
        <Col
          xl={22.5}
          lg={22.5}
          md={22.5}
          sm={22.5}
          xs={22}
          style={{
            margin: "0 auto",
          }}
        >
          <span className="Info_intro__H__divider"></span>
        </Col>
      )}
      <Col xl={24} lg={24} md={22} sm={24} xs={24} className="c__Intro">
        {intro && (
          <>
            <Col
              xl={22}
              lg={22}
              md={22}
              sm={22}
              xs={22}
              className="c__Intro__Title"
            >
              <h2 style={{ all: "unset" }}>
                {`${IntroductionDic.intro[`${lang}`]} ${
                  intro ? intro.FirstName + " " + intro.LastName : ""
                }`}
              </h2>
            </Col>
            {intro && (
              <Col
                xl={22}
                lg={22}
                md={24}
                sm={22}
                xs={22}
                className={` c__Intro__Desc ${
                  toggled === true ? "expand" : "collapse"
                }`}
              >
                {/* <Text */}
                {/* lang={lang} */}
                {/* > */}
                {needToggle === true && toggled === false
                  ? intro.AboutMe.slice(0, MaxCharAboutMe) + "  ...  "
                  : intro.AboutMe}
                {/* </Text> */}
                {needToggle === true && (
                  <Col
                    onClick={ToggleController}
                    className="o__AboutMeToggleController"
                  >
                    {`${toggled === false ? "بیشتر" : "بستن"}`}
                  </Col>
                )}
              </Col>
            )}
          </>
        )}
      </Col>
    </Section>
  );
};

export default Introduction;
